import React from "react";

import { css } from "@emotion/css";
import { QueryAwait } from "@steto-care/steto-query";
import { Outlet } from "@tanstack/react-router";

import { useStyles } from "@/hooks/useStyles.ts";
import { CenteredLoader } from "@/uiKit/atoms/Loader.tsx";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";
import { PatientSyncNavigationHeader } from "@/uiKit/organisms/PatientSync/PatientSyncNavigationHeader.tsx";

export const PatientSyncTemplate: React.FC = () => {
  const styles = useStyles(makeStyles);

  return (
    <>
      <title>{`Stēto - Sync`}</title>
      <QueryAwait errorFallback={() => null} pendingFallback={() => null}>
        <PatientSyncNavigationHeader />
      </QueryAwait>
      <section id="patient-sync-layout-main" className={styles.main}>
        <QueryAwait errorFallback={HandledErrorCard} pendingFallback={CenteredLoader}>
          <Outlet />
        </QueryAwait>
      </section>
    </>
  );
};

const makeStyles = () => ({
  main: css({
    display: "flex",
    flexDirection: "column",
  }),
});
